// Product End Points
export const product = {
  getProducts: "/tntechapi/product/getProducts",
  createProduct: "/tntechapi/product/createProduct",
  updateProduct: "/tntechapi/product/updateProduct",
  deleteProduct: "/tntechapi/product/deleteProduct",
};

//Product Type End Points
export const productType = {
  getProductTypes: "/tntechapi/productType/getProductTypes",
  getMovingHistory: "/tntechapi/productType/getMovingHistory",
  createProductType: "/tntechapi/productType/createProductType",
  updateProductType: "/tntechapi/productType/updateProductType",
  updatePairsByUniqueStockID: "/tntechapi/productType/updatePairsByUniqueStockID",
  deleteProductType: "/tntechapi/productType/deleteProductType",
  deleteDirectEntryProductType: "/tntechapi/productType/deleteDirectEntryProductType",
};

//Product Type With Out HUIDEnd Points
export const productTypeWithOutHUID = {
  getProductTypeWithOutHUIDs:
    "/tntechapi/productTypeWithOutHUID/getProductTypeWithOutHUIDs",
  createProductTypeWithOutHUID:
    "/tntechapi/productTypeWithOutHUID/createProductTypeWithOutHUID",
  updateProductTypeWithOutHUID:
    "/tntechapi/productTypeWithOutHUID/updateProductTypeWithOutHUID",

  moveProductType: "/tntechapi/productTypeWithOutHUID/moveProductType",
  deleteProductTypeWithOutHUID:
    "/tntechapi/productTypeWithOutHUID/deleteProductTypeWithOutHUID",
};

//Customer End Points
export const customer = {
  getCustomers: "/tntechapi/customer/getCustomers",
  createCustomer: "/tntechapi/customer/createCustomer",
  updateCustomer: "/tntechapi/customer/updateCustomer",
  deleteCustomer: "/tntechapi/customer/deleteCustomer",
};

//User End Points
export const user = {
  getUsers: "/tntechapi/user/getUsers",
  createUser: "/tntechapi/user/createUser",
  updateUser: "/tntechapi/user/updateUser",
  deleteUser: "/tntechapi/user/deleteUser",
};

//User End Points
export const order = {
  getOrders: "/tntechapi/order/getOrders",
  getOrderProducts: "/tntechapi/order/getOrderProducts",
  createOrder: "/tntechapi/order/createOrder",
  createOrderProduct: "/tntechapi/order/createOrderProduct",
  updateOrder: "/tntechapi/order/updateOrder",
  updateOrderProduct: "/tntechapi/order/updateOrderProduct",
  deleteOrder: "/tntechapi/order/deleteOrder",
  deleteOrderProduct: "/tntechapi/order/deleteOrderProduct",
  checkHUIDStocks: "/tntechapi/order/checkHUIDStocks",
  updateStocksByHUID: "/tntechapi/order/updateStocksByHUID",
};

//User End Points
export const personalDetail = {
  getPersonalDetails: "/tntechapi/personalDetails/getPersonalDetails",
  createPersonalDetails: "/tntechapi/personalDetails/createPersonalDetails",
  updatePersonalDetails: "/tntechapi/personalDetails/updatePersonalDetails",
  deletePersonalDetails: "/tntechapi/personalDetails/deletePersonalDetails",
};

//Reports End Points
export const reports = {
  getOrderReports: "/tntechapi/reports/getOrderReports",
};

//Ledgers End Points
export const ledgers = {
  getLedgers: "/tntechapi/ledger/getLedgers",
  getLedgersByCustomerID: "/tntechapi/ledger/getLedgersByCustomerID",
  createLedger: "/tntechapi/ledger/createLedger",
  updateLedger: "/tntechapi/ledger/updateLedger",
  deleteLedger: "/tntechapi/ledger/deleteLedger",
};

//export const baseURL = process.env.BASEURL;
export const baseURL = "https://tntech.moiaccount.in";
//export const baseURL = "http://localhost:8002";
